import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from '@hooks/storeHooks';
import { SnacksSliceState, SnackState } from '../../types';

const initialState: SnacksSliceState = {
  snacks: [],
};

export const snackSlice = createSlice({
  name: 'snack',
  initialState,
  reducers: {
    addSnack: (
      state,
      {
        payload: { noDuplicates = false, clear = false, ...newSnack },
      }: PayloadAction<SnackState & { noDuplicates?: boolean; clear?: boolean }>,
    ) => {
      if (clear) state.snacks = [];

      const index = state.snacks.findIndex((snack) => snack.message === newSnack.message);

      if (noDuplicates && index !== -1) return;
      state.snacks.push({ timeout: 5000, ...newSnack });
    },
    clearSnack: (state, { payload }) => {
      state.snacks.splice(payload, 1);
    },
    clearAllSnacks: (state) => {
      state.snacks = [];
    },
  },
});

export const { addSnack, clearSnack, clearAllSnacks } = snackSlice.actions;

export const useSnacks = () => useAppSelector((state) => state.snack.snacks);

const snackReducer = snackSlice.reducer;
export default snackReducer;
